<template>
  <div class="load-bag" v-if="showLoader2">
  <div class="lds-ripple" ><div></div><div></div></div>
  </div>
     <Dashboard/>
      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Parking Management</h1>
            <div class="section-header-breadcrumb">
              <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
              <div class="breadcrumb-item">Parking Management</div>
            </div>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header d-Fle">
                    <h4 class="hide">Export Table</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive newPc">
                      <table
                        class="table table-bordered table-hover"
                        id="tableExport"
                        style="width: 100%"
                      >
                        <thead>
                          <tr>
                            <th>S No.</th>
                            <th>Parking Name</th>
                            <th>Spot Location</th>
                            <th>No. of Spots</th>
                            <th>Price/hr</th>
                            <th>Parking Type</th>
                            <th>Parking Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item,index) in result" :key="item._id">
                            <td>{{index+1}}</td>
                            <td>{{item.parking_name.replace(/^./, item.parking_name[0].toUpperCase())}}</td>
                            <td>{{item.address}}, {{item.city}}, {{item.state}}</td>
                            <td>{{item.spots}}</td>
                            <td>{{item.price}} $</td>
                            <td v-if="item.parking_type=1">Private</td>
                            <td v-else>Public</td>
                            <td>
                              <button class="btn featured" @click="Active(item._id, item.is_spot_active)"  v-if="(item.is_spot_active == 1)" style="color:green">Active</button>
                              <button class="btn featured" @click="Active(item._id, item.is_spot_active)"  v-else style="color:red">Inactive</button>
                            </td>
                            <td class="action">
                               <!-- <router-link to="/addcontent"><i class="far fa-eye"></i></router-link> -->
                              <a @click="DeleteParking(item._id)"><i class="far fa-trash-alt"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </section>
      </div>
</template>
<script>
// import {DoubleBounce} from 'vue-loading-spinner'
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import Dashboard from '@/components/Dashboard.vue'
import axios from "../services/customAxios";
import { base_url } from "../config";
export default defineComponent({
  name: 'UserManagement',
  components: {
    Dashboard,
    // DoubleBounce
  },
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data(){
    return{
      result:[],       
      base_url: base_url,
      is_spot_active:"",
      showLoader:false,
      showLoader2:true,
    }
  },
  methods:{
    async Active(_id , is_spot_active) {
      if (!is_spot_active) {
       let response = await axios.put(`${base_url}/active_deactive_parking/`+_id, {
        is_spot_active: 1,
      });
      createToast({title: "Success", description: response.data.message},{type: "success"})
      } else {
        let response = await axios.put(`${base_url}/active_deactive_parking/`+_id, {
          is_spot_active: 0,
          });
          createToast({title: "Success", description: response.data.message},{type: "success"})
      }
      this.LoadParking();
    },
    async LoadParking() {
      try{
      let response = await axios.get(`${base_url}/get_all_parking`); 
      console.log("Parkings==========>>>>>",response.data.result);
      this.result = response.data.result.reverse();
    }
    catch (error) {
      if (error) {
        this.showLoader= false;
          this.result = [];
        }
      }
    },
    async DeleteParking(_id) {
      if (confirm("Are you sure you want to delete this Parking Spot?")) {
         await axios.delete(`${base_url}/delete_parking/` + _id);
        this.LoadParking();
      }
    }, 
  },
  async mounted(){
    this.LoadParking();
    // this.loadmodal();
    
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
    setTimeout(() => {
      document.body.appendChild(recaptchaScript)  
      this.showLoader2= false
    }, 3000);  
  }
});
</script>

<style>
.imageSize{
  height: 65px;
  width: 65px;
  margin: 5px 0;
  border: 1px solid rgb(12, 176, 127);
  border-radius: 5px;
}
.hide{
  visibility: hidden;
}
</style>

